
import { defineComponent, PropType } from 'vue'

// components
import Loader from '@/common/components/UI/Loader/index.vue'
import Pagination from '@/common/components/UI/Pagination/index.vue'

export default defineComponent({
    components: {
        loader: Loader,
        pagination: Pagination,
    },
    props: {
        items: {
            type: Array as PropType<any[]>,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        pagination: {
            type: Boolean,
            default: false,
        },
        paginationTotalPages: {
            type: Number,
            default: 1,
        },
        paginationLimit: {
            type: Number,
            default: 1,
        },
        paginationTotalItems: {
            type: Number,
            default: 1,
        },
        paginationCurrentPage: {
            type: Number,
            default: 1,
        },
    },
    setup(_, { emit }) {
        const emitChangePage = (page: number) => {
            emit('change-page', page)
        }

        return { emitChangePage }
    },
})
